.footer {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: var(--space-sm);
  padding: var(--space-lg) var(--space-md);
  margin: var(--space-2xl) 0 0 0;
  border-top: var(--border-width) solid var(--color-secondary);
}

.copyright {
  font-size: var(--fs-10);
  color: var(--color-primary);
}

.copyrightWave {
  font-size: var(--fs-7);
  color: var(--color-primary);
}
